module.exports = __webpack_public_path__ + "static/media/running.5b0cb078.svg";